import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var HOST = window.location.hostname;
var CONFIGS = {
  localhost: {
    apiUrl: 'http://localhost:5800',
    authHostsPattern: 'localhost',
    consoleUrl: 'http://localhost:5911',
    firebaseVapidKey: 'BDfrxcQCgfRRDnFOvHJNLweI2ExccdVLSEP-n2ohg-bLEj0L9qoDFKF8b6UAGSRD58EX_IczilLv3KwBFzq-A0Y',
    landingPageUrl: 'http://localhost:5910',
    landingPageQuitejaUrl: 'http://localhost:5002',
    exibirVersao: true,
    name: 'development',
    apiValidatorUrl: 'http://localhost:5006'
  },
  'app.melembre.gorillascode.com': {
    apiUrl: 'https://api.melembre.gorillascode.com',
    authHostsPattern: 'app.melembre.gorillascode.com',
    consoleUrl: 'https://console.melembre.gorillascode.com',
    firebaseVapidKey: 'BDfrxcQCgfRRDnFOvHJNLweI2ExccdVLSEP-n2ohg-bLEj0L9qoDFKF8b6UAGSRD58EX_IczilLv3KwBFzq-A0Y',
    landingPageUrl: 'https://melembre.gorillascode.com',
    landingPageQuitejaUrl: 'https://quiteja.staging.gorillascode.com',
    exibirVersao: true,
    name: 'staging',
    apiValidatorUrl: 'https://validator.staging.gorillascode.com'
  },
  'app.melembre.com.br': {
    apiUrl: 'https://api.melembre.com.br',
    authHostsPattern: 'app.melembre.com.br',
    consoleUrl: 'https://console.melembre.com.br',
    firebaseVapidKey: 'BDfrxcQCgfRRDnFOvHJNLweI2ExccdVLSEP-n2ohg-bLEj0L9qoDFKF8b6UAGSRD58EX_IczilLv3KwBFzq-A0Y',
    landingPageUrl: 'https://melembre.com.br',
    landingPageQuitejaUrl: 'https://quiteja.com.br',
    exibirVersao: false,
    name: 'production',
    apiValidatorUrl: 'https://validator.quiteja.com.br'
  }
};
if (HOST.includes("pr-")) {
  CONFIGS[HOST] = {
    apiUrl: 'https://api.melembre.gorillascode.com',
    authHostsPattern: 'app.melembre.gorillascode.com',
    consoleUrl: 'https://console.melembre.gorillascode.com',
    firebaseVapidKey: 'BDfrxcQCgfRRDnFOvHJNLweI2ExccdVLSEP-n2ohg-bLEj0L9qoDFKF8b6UAGSRD58EX_IczilLv3KwBFzq-A0Y',
    landingPageUrl: 'https://melembre.gorillascode.com',
    landingPageQuitejaUrl: 'https://quiteja.staging.gorillascode.com',
    exibirVersao: true,
    name: 'staging',
    apiValidatorUrl: 'https://validator.staging.gorillascode.com'
  };
} else if (!CONFIGS[HOST]) {
  CONFIGS[HOST] = {
    apiUrl: "http://".concat(HOST, ":5800/"),
    authHostsPattern: "".concat(HOST),
    authTokenCookieDomain: "".concat(HOST),
    dealAppWebV1Url: "http://".concat(HOST, ":8282/#"),
    landingUrl: "http://".concat(HOST, ":5002"),
    name: "development",
    showLogout: true,
    showVersion: true
  };
}
export default {
  apiUrl: CONFIGS[HOST].apiUrl,
  authHostsPattern: CONFIGS[HOST].authHostsPattern,
  // URL do Console do MeLembre
  consoleUrl: CONFIGS[HOST].consoleUrl,
  // Vapid Key do Firebase. Usado para receber as notificações do FCM.
  firebaseVapidKey: CONFIGS[HOST].firebaseVapidKey,
  landingPageUrl: CONFIGS[HOST].landingPageUrl,
  // URL da landing page da QuiteJá
  landingPageQuitejaUrl: CONFIGS[HOST].landingPageQuitejaUrl,
  name: CONFIGS[HOST].name,
  // Indica se será exibida a versão da aplicação na tela
  exibirVersao: CONFIGS[HOST].exibirVersao,
  apiValidatorUrl: CONFIGS[HOST].apiValidatorUrl
};